import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Form, FormGroup, Input, Row } from "reactstrap";
import { useAuth } from "context/AuthProvider";
import MesCalendarioEmpleado from "./MesCalendarioEmpleado";
import { apiEmpleadosService } from "services/apiEmpleadosService";
import { apiFestivosService } from "services/apiFestivosService";

const CalendarioEmpleadoImpl = () => {
  const {empleado} = useAuth()
  const [anno, setAnno] = useState(new Date().getFullYear());
  const [selectedEmpleado, setSelectedEmpleado] = useState(null);
  const [festivosPorMes, setFestivosPorMes] = useState(Array.from({length:12}, ()=>[]));
  

  useEffect(() => {
    const fetchData = async () =>{
      const response = await apiEmpleadosService.get(empleado.empresaId, empleado.id);
      setSelectedEmpleado(response)
    }
    fetchData()
  }, [empleado.empresaId, empleado.id])
  
  // Fetch all festivos for the year and group them by month (single request)
  useEffect(() => {
    const fetchFestivosAnno = async () => {
      if(!anno || !selectedEmpleado || !selectedEmpleado.centroId) return;
      try{
        const response = await apiFestivosService.getByAnnoAndCentroId(anno, selectedEmpleado.centroId);
        const mesesUpper = ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];
        const agrupado = Array.from({length:12}, ()=>[]);
        (response || []).forEach(f => {
          const idx = mesesUpper.indexOf((f.mes || '').toString().toUpperCase());
          if(idx >= 0) agrupado[idx].push(f.dia);
        });
        setFestivosPorMes(agrupado);
      }catch(err){
        setFestivosPorMes(Array.from({length:12}, ()=>[]));
      }
    }

    fetchFestivosAnno();
  }, [anno, selectedEmpleado]);

  


  return (
    <>

      <Row>
        <Col>
          <Form>
            <div className="pl-lg-4">
              <Row>
                <Col lg="2">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-email">
                      Año
                    </label>
                    
                      <Input type="number"
                        name="anno"
                        id="anno"
                        value={anno}
                        onChange={(e) => setAnno(e.target.value)}
                      />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Form>
        </Col>
      </Row>
     
      {anno !== "null" && selectedEmpleado !== null ? (
        <>
         <Row>
        <Col> <Card className="shadow"><CardBody> <span className="text-info">Vacaciones</span> <span className="text-warning">Bajas</span> <span className="text-yellow">Ausencias</span> <span className="text-danger">Festivos</span></CardBody></Card> </Col>
      </Row>
          <Row className="mt-2">
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={0}
                empleado={selectedEmpleado}
                nombreMes={"ENERO"}
                diasFestivos={festivosPorMes[0]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={1}
                empleado={selectedEmpleado}
                nombreMes={"FEBRERO"}
                diasFestivos={festivosPorMes[1]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={2}
                empleado={selectedEmpleado}
                nombreMes={"MARZO"}
                diasFestivos={festivosPorMes[2]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={3}
                empleado={selectedEmpleado}
                nombreMes={"ABRIL"}
                diasFestivos={festivosPorMes[3]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={4}
                empleado={selectedEmpleado}
                nombreMes={"MAYO"}
                diasFestivos={festivosPorMes[4]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={5}
                empleado={selectedEmpleado}
                nombreMes={"JUNIO"}
                diasFestivos={festivosPorMes[5]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={6}
                empleado={selectedEmpleado}
                nombreMes={"JULIO"}
                diasFestivos={festivosPorMes[6]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={7}
                empleado={selectedEmpleado}
                nombreMes={"AGOSTO"}
                diasFestivos={festivosPorMes[7]}
              ></MesCalendarioEmpleado>
            </Col>{" "}
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={8}
                empleado={selectedEmpleado}
                nombreMes={"SEPTIEMBRE"}
                diasFestivos={festivosPorMes[8]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={9}
                empleado={selectedEmpleado}
                nombreMes={"OCTUBRE"}
                diasFestivos={festivosPorMes[9]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={10}
                empleado={selectedEmpleado}
                nombreMes={"NOVIEMBRE"}
                diasFestivos={festivosPorMes[10]}
              ></MesCalendarioEmpleado>
            </Col>
            <Col lg="4">
              <MesCalendarioEmpleado
                anno={anno}
                mes={11}
                empleado={selectedEmpleado}
                nombreMes={"DICIEMBRE"}
                diasFestivos={festivosPorMes[11]}
              ></MesCalendarioEmpleado>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default CalendarioEmpleadoImpl;
